import { DashboardController } from '../../dashboard/DashboardController';
import template from '../../dashboard/DashboardView.html';
const Dashboard = {
    template,
    controller: DashboardController,
    controllerAs: '$ctrl',
    bindings: {
        page: '@',
        params: '@',
    },
};
export default Dashboard;
